import { fireOnce, trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackMedicationAssessmentButtonViewed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) => {
  const event = {
    action: 'medication-assessment-button-viewed',
    category: getCategory(args.interviewType),
    property: '',
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackMedicationAssessmentButtonClicked = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) =>
  trackStructuredEvent({
    action: 'medication-assessment-button-clicked',
    category: getCategory(args.interviewType),
    property: '',
    label: args.interviewToken,
  });

export const trackMedicationAssessmentViewed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  medication: string;
}) => {
  const event = {
    action: 'medication-assessment-viewed',
    category: getCategory(args.interviewType),
    property: args.medication,
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackMedicationAssessmentNotFoundDisplayed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  medication: string;
}) => {
  const event = {
    action: 'medication-assessment-not-found',
    category: getCategory(args.interviewType),
    property: args.medication,
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackRelatedPartnerCardViewed = ({
  impressionId,
  url,
  interviewType,
}: {
  impressionId: string;
  url?: string;
  interviewType: MiniInterviewType;
}) => {
  const event = {
    action: 'medication-assessment-partner-card-viewed',
    category: getCategory(interviewType),
    label: impressionId,
    property: url,
  };

  const key = `${event.category}:${event.action}:${event.label}:${event.property}`;

  fireOnce(() => trackStructuredEvent(event), key);
};

export const trackRelatedPartnerCtaClicked = ({
  impressionId,
  interviewType,
  url,
}: {
  impressionId: string;
  interviewType: MiniInterviewType;
  url?: string;
}) => {
  const event = {
    action: 'medication-assessment-partner-card-clicked',
    category: getCategory(interviewType),
    label: impressionId,
    property: url,
  };

  const key = `${event.category}:${event.action}:${event.label}:${event.property}`;

  fireOnce(() => trackStructuredEvent(event), key);
};
